// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__3bp_b","col":"styles_col__2cWJ1"};